import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  Output,
  EventEmitter
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ioh-level-two-svg',
  template: `<div #svgContainer class="ioh-svg-container"></div>`,
  styles: [
    `
      .ioh-svg-container {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .ioh-svg-container svg {
        width: 100%;
        height: 100%;
      }
    `
  ]
})
export class IOHLevelTwoSvgComponent implements OnInit {
  terminalElements: Element[] = [];
  terminalElementsMap: any = {};
  @Output() corridorChange: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.loadSvg();
  }

  //method to load level 2 svg
  loadSvg() {
    const svgVersion = environment.appConfig.svgVersion;
    this.http
      .get(`/assets/ioh/svg/IOH_Level_2.svg?version=${svgVersion}`, {
        responseType: 'text'
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe(svgContent => {
        const parser = new DOMParser();
        const svg = parser
          .parseFromString(svgContent, 'image/svg+xml')
          .querySelector('svg');

        if (svg) {
          const svgContainer =
            this.el.nativeElement.querySelector('.ioh-svg-container');
          this.renderer.appendChild(svgContainer, svg);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
